import React from 'react';
import './slider-woodteclinear.css';
import Woodteclinear1 from '../../images/woodtec/5.webp';
import Woodteclinear2 from '../../images/woodtec/5.webp';

function slider() {
	return (
	  
	<>
	<div id="slider-woodteclinear">
		<div id="carouselExampleIndicators2" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators2" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Woodteclinear1} alt="Woodteclinear1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>LINEAR ACOUSTIC PANEL</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Woodteclinear2} alt="Woodteclinear2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>LINEAR ACOUSTIC PANEL</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;